namespace advisorop.components.meetinghub {
    export class MeetingDocumentListController {
        documents: Array<domains.IDmsDocument>;
        onDocumentDelete: any;

        dgDocumentListOptions: DevExpress.ui.dxDataGridOptions;
        puConfirmDeletion: DevExpress.ui.dxPopupOptions;
        showConfirmDeletion: boolean = false;
        confirmDeletionTitle: string;
        documentToDelete: domains.IDmsDocument;
        meetingId: number;
        meetingGuid: string;
        household: domains.IHousehold;
        householdReportButtonLabel: string = "Create Household Report";
        generatingHHReport: boolean = false;

        constructor(private meetingHubService: services.MeetingHubService) {
            this.dgDocumentListOptions = {
                bindingOptions: {
                    dataSource: "vm.documents"
                },
                columns: [
                    { dataField: "documentName", },
                    { dataField: "documentDescription", },
                    { dataField: "version", },
                    { dataField: 'id', caption: '', cellTemplate: 'btnActions' }
                ],
            }

            this.puConfirmDeletion = {
                deferRendering: false,
                width: 400,
                height: 300,
                contentTemplate: "confirmDeletionTemplate",
                showTitle: true,
                dragEnabled: false,
                closeOnOutsideClick: true,
                bindingOptions: {
                    visible: "vm.showConfirmDeletion",
                    title: "vm.confirmDeletionTitle"
                },
                toolbarItems: [
                    {
                        widget: "dxButton",
                        location: "center",
                        toolbar: "bottom",
                        options: {
                            text: "Delete",
                            onClick: () => {
                                this.deleteDocument();
                            }
                        }
                    },
                    {
                        widget: "dxButton",
                        location: "after",
                        toolbar: "bottom",
                        options: {
                            text: "Cancel",
                            onClick: () => {
                                this.cancelDeletion();
                            }
                        }
                    }
                ]
            }
        }

        canDelete(document: domains.IDmsDocument): boolean {
            return true;
        }

        setDocumentToDelete(document: domains.IDmsDocument): boolean {
            this.confirmDeletionTitle = "Delete " + document.documentName;
            this.showConfirmDeletion = true;
            this.documentToDelete = document;
            return true;
        }

        hideDeletionPopup(): void {
            this.confirmDeletionTitle = "";
            this.showConfirmDeletion = false;
            this.documentToDelete = undefined;

        }

        deleteDocument(): boolean {
            this.meetingHubService.disableDocument(this.documentToDelete).then(resp => {
            //    if (this.onDocumentDelete) {
            //        this.onDocumentDelete();
            //    }
            }).catch(err => {
                console.log(err);
            }).finally(() => {
                this.hideDeletionPopup();
            })
            return true;
        }

        cancelDeletion(): void {
            this.hideDeletionPopup();
        }

        onAddHouseholdReport(): void {
            this.generatingHHReport = true;
            this.meetingHubService.addHouseholdReport(this.meetingGuid, this.meetingId, this.household.id, true, true, true).then(resp => {
                console.log("Household report added");
            }).finally(() => {
                this.generatingHHReport = false;
            })
        }

        $onInit(): void {
        }

        $onChanges(evt): void {
            if (evt.household != undefined) {
                this.householdReportButtonLabel = "Create Household Report";
                if (this.household != undefined) {
                    this.householdReportButtonLabel += "(" + this.household.name + ")";
                }
            }
        }
    }

    class MeetingDocumentList implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
                documents: '<',
                meetingId: '<',
                meetingGuid: '<',
                household: '<',
                onDocumentDelete: '&',
            };
            this.controller = [`meetingHubService`, MeetingDocumentListController];
            this.controllerAs = `vm`;
            this.templateUrl = `spa/meeting-hub-module/components/meeting-document-list.html`;
        }
    }
    angular.module(Constants.APP).component(`meetingDocumentList`, new MeetingDocumentList());
}